import { render, staticRenderFns } from "./portfoliocolumnsconfig.vue?vue&type=template&id=5af1eb05&scoped=true&"
import script from "./portfoliocolumnsconfig.vue?vue&type=script&lang=js&"
export * from "./portfoliocolumnsconfig.vue?vue&type=script&lang=js&"
import style0 from "./portfoliocolumnsconfig.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./portfoliocolumnsconfig.vue?vue&type=style&index=1&id=5af1eb05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af1eb05",
  null
  
)

export default component.exports